export enum EFeaturedFlags {
  CustomFeed = 'customFeed',
  CreateSpark = 'createSparks',
  InteractSpark = 'interactSparks',
  ViewSparks = 'viewSparks',
  ShowChannelsTab = 'showChannelsTab',
  ShowEveryoneTab = 'showEveryoneTab',
  CardV2 = 'cardV2',
}
